import { ActionTypes } from '../constants/actionTypes/tdmSearch';

const tdmSearchReducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.TDM_SEARCH_CONTROL_INIT_SUCCESS:
      return {
        ...state,
        labels: action.labels,
        departures: action.data.departureAirports,
        selectedDeparture: action.data.selectedDeparture,
        selectedDepartureDate: action.data.selectedDepartureDate,
        roomDistribution: action.data.roomDistribution,
        isLoading: false,
      };

    case ActionTypes.TDM_SEARCH_CONTROL_INIT_FAIL:
      return {
        ...state,
        labels: action.labels,
        isLoading: false,
      };

    case ActionTypes.TDM_SEARCH_CONTROL_CHANGE_DEPARTURE_AIRPORT:
      return {
        ...state,
        selectedDeparture: action.departureAirport,
      };

    case ActionTypes.TDM_SEARCH_CONTROL_CHANGE_DEPARTURE_DATE:
      return {
        ...state,
        selectedDepartureDate: action.selectedDepartureDate,
      };

    case ActionTypes.TDM_SEARCH_CONTROL_CHANGE_ROOM_DISTRIBUTION:
      return {
        ...state,
        roomDistribution: action.roomDistribution,
        selectedNumberOfRooms: action.selectedNumberOfRooms,
      };

    default:
      return state;
  }
};

export default tdmSearchReducer;
